import React, { Component } from 'react'
import Link from 'next/link'
import { IonIcon } from 'controls'

import { quickAccess } from './styles'
import { container } from '../styles'

class QuickAccess extends Component {
  render() {
    const { calls } = this.props
    const { response: reponseLeads } = this.props.leads
    const { response: responseMessages } = this.props.messages
    const leadsCount = reponseLeads ? reponseLeads.count : 0
    const messagessCount = responseMessages ? responseMessages.count : 0

    return (
      <section className="wp container">
        <div className="stadistics">
          <div className="container">
            <div className="stadistic">
              <Link href="/dashboard/property-management">
                <a>
                  <strong>{leadsCount}</strong>
                  <p>Total de propiedades</p>
                  <IonIcon icon="md-home icon" />
                </a>
              </Link>
            </div>
            <div className="stadistic">
              <Link href="/dashboard/contacts/messages">
                <a>
                  <strong>{messagessCount}</strong>
                  <p>Mensajes de portales</p>
                  <IonIcon icon="md-mail-open icon" />
                </a>
              </Link>
            </div>
            <div className="stadistic">
              <Link href="/dashboard/contacts/calls">
                <a>
                  <strong>{calls.length}</strong>
                  <p>
                    LLamadas recibidas
                    <br />
                    <span>este mes</span>
                  </p>
                  <IonIcon icon="ios-call icon" />
                </a>
              </Link>
            </div>
          </div>
        </div>
        <style jsx>{quickAccess}</style>
        <style jsx>{container}</style>
      </section>
    )
  }
}

export default QuickAccess
